import React from 'react';
import useInView from '../hooks/useInView';

const Reveal = ({
  as: Tag = 'div',
  animation = 'up',
  delay = 0,
  className = '',
  children,
  ...rest
}) => {
  const [ref, inView] = useInView();

  return (
    <Tag
      ref={ref}
      className={`reveal reveal-${animation}${inView ? ' in-view' : ''}${className ? ` ${className}` : ''}`}
      style={{ transitionDelay: inView ? `${delay}ms` : '0ms' }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
